import { Container, Typography } from '@material-ui/core'
import { useEffect } from 'react'
import { observer } from 'mobx-react-lite'
import { useDMEStore } from '../../store'
import useStyles from './styles'
import { UI } from '../../../global'
import PLPView from '../PLPView'
import PhysicianSearchView from '../PhysicianSearchView'
import { CUSTOMER_INFORMATION_PATH } from '../../constants'
import CheckoutJourneyStepsWidget from '../../widgets/CheckoutJourneyStepsWidget'
import CustomerInformationForm from '../../forms/CustomerInformationForm'
import CheckoutJourneyWrapperWidget from '../../widgets/CheckoutJourneyWrapperWidget'

const CustomerInformationView: UI.ViewComponent<UI.LifeCycle> = observer(
  ({ router, onComponentDidMount }) => {
    const store = useDMEStore()
    const classes = useStyles()

    if (!store.cart.product.present) {
      PLPView.location!(router)
      return null
    }

    useEffect(() => {
      onComponentDidMount()
    }, [])

    function handleOnFormSuccess() {
      if (store.insurance.requiresPrescription) {
        PhysicianSearchView.location!(router)
      } else {
        store.cart.checkout({
          onSuccess: (response) => {
            window.location.href = response.checkoutPageUrl
          },
        })
      }
    }

    return (
      <Container className={classes.viewContainer}>
        <CheckoutJourneyWrapperWidget>
          <CheckoutJourneyStepsWidget currentPath={CUSTOMER_INFORMATION_PATH} />
          <Typography
            gutterBottom
            className={classes.disclaimer}
            variant="body1"
          >
            Please enter the below information so we can verify the patient's
            insurance is active.
          </Typography>
          <CustomerInformationForm onSuccess={handleOnFormSuccess} />
        </CheckoutJourneyWrapperWidget>
      </Container>
    )
  }
)

CustomerInformationView.location = (router) => {
  if (router) {
    router.push(CUSTOMER_INFORMATION_PATH)
  } else {
    window.location.href = CUSTOMER_INFORMATION_PATH
  }
}

export default CustomerInformationView
